import {createFileRoute, redirect} from '@tanstack/react-router';
import {STAFF_SLUG_KEY} from '@/features/auth/hooks';

export const Route = createFileRoute('/_auth/auth/login-infostart')({
  loaderDeps: ({search}) => {
    return {search};
  },
  loader: ({deps: {search}}) => {
    window.localStorage.setItem(STAFF_SLUG_KEY, `"${import.meta.env.VITE_INFOSTART_STAFF_ID}"`);
    throw redirect({
      to: '/auth/signin',
      search: search,
    });
  },
});
